import { appConfigConstants } from "@/configurations/app-configs/app.config.constants"
import { replaceStartSlash } from "@/helpers/global/env.func"

export const SERVICES_REQUEST = {
  COMMON: replaceStartSlash(`${appConfigConstants.itradePath}/services`, false),
  SECURE: replaceStartSlash(`${appConfigConstants.itradePath}/services/secure`, false),
  EQT: replaceStartSlash(`${appConfigConstants.itradePath}/services/eqt`, false),
  FNO: replaceStartSlash(`${appConfigConstants.itradePath}/services/fno`, false),
  AUTH: replaceStartSlash(`${appConfigConstants.itradePath}/services/auth`, false),
  WIN_VEST: appConfigConstants.winvestorPath,
  MDS: 'mds',
  IPO: replaceStartSlash(`${appConfigConstants.itradePath}/services/eqt/ipo`, false),
  CA: replaceStartSlash(`${appConfigConstants.itradePath}/services/eqt/ca`, false),
  COMMON_V1: replaceStartSlash(`${appConfigConstants.itradePath}/services/v1`, false),
  COMMON_QUOTE: replaceStartSlash(`${appConfigConstants.itradePath}/services/quote`, false)
}

export const ENDPOINT_REQUEST = {
  mdsINSTRUMENT: {

  },
  iSEC: {
    GENERATE_NEW_OTP: 'generateotp',
    NEW_OTP: 'newotp',
    VERIFY_OTP: 'verifyotp',
    SECURE_RANDOM_CODE: 'secureRandomCode'
  },
  iAUTH: {
    PRE_ACTIVE_ACCOUNT: '/activate/preactiveaccount',
    ACTIVE_ACCOUNT: '/activate/activeaccount',
    USER_LOGIN: 'user/login',
    USER_LOGOUT: 'user/logout',
    USER_REGISTER: 'user/register',
    USER_CHECK_AUTH: 'user/checkauthen',
    CHANGE_PW: 'changepw',
    IMAGE_CAPTCHA: 'imgcaptcha',
    IMAGE_CAPTCHA_BY_WS: 'getCaptchaByWS',
    USER_VALIDATE: 'user/validate',
    USER_RESET_PASSWORD: 'user/resetpwd',
    USER_CHANGE_PASSWORD: 'user/changepwd',
    USER_UPDATE_INFO: 'user/{0}/update', // {0}: clientID,
    OTP_REGISTER:'otpRegister',
    OTP_REGISTER_VERIFY:'otpRegisterVerify',
    USER_CHECK_SESSION: 'user/checkSession',
    OTP_TICKET_VERIFY: 'otp/otpTicketVerify',
    APPLY_SELF_DEFINED_USER_ID:'client/applySelfDefinedUserID',
    IDENTITY_CARD_TYPE:'queryOptionItem' ,
    BCAN_STATUS: 'client/bcanStatusEnquiry',
    BCAN_CONSENT: 'client/bcanConsent',
    ACCOUNT_DETAIL:'client/getAccountDetails',
    BANK_ACCOUNT_REGISTER: "client/bankAccountRegister",
    EDDA_REGISTER: "client/eddaRegister",
    ACCOUNT_DETAILS: "client/getAccountDetails",
  },
  iTRADE: {
    GET_TRADING_ACCOUNT: 'user/gettradingaccount',
    SWITCH_TRADING_ACCOUNT: 'user/switchtradingaccount',
    SET_DEFAULT_TRADING_ACCOUNT: 'user/setdefaulttradingaccount',
    CLIENT: {
      GET_BANK_ACCOUNT: 'client/{0}/getbankaccount', // {0}: clientID
      GET_ACCOUNT_BALANCE: 'client/{0}/accountbalance', // {0}: clientID
      GET_PORTFOLIOS: 'client/{0}/portfolios', // {0}: clientID
      GET_TRANSACTION_HISITORY: 'client/{0}/transactionhistory', // {0}: clientID
      GET_AVAILABLE_QUANTITY: 'client/{0}/availablequantity', // {0}: clientID
      GET_BANK_BALANCE: 'client/{0}/bankbalance', // {0}: clientID
      GET_STATEMENT_LIST: 'client/{0}/estatementListEnquiry', // {0}: clientID
      GET_STATEMENT_CONTENT: 'client/{0}/estatementContentEnquiry', // {0}: clientID
      ENQUIRY_BUYING_POWER: 'client/{0}/buyingpower', // {0}: clientID
      UPDATE_BANK_ACCOUNT: "client/bankAccountUpdate",
      QUREY_ACCOUNT_DETAILS: "client/queryAccountDetails",
      CREATE_TRADING_ACC: "client/createTradingAcc",
    },
    ORDER: {
      GET_ORDER_BOOK: 'order',
      GET_ORDER_HISTORY: 'client/{0}/orderhistory', // {0}: clientID
      CANCEL_ORDER: 'order/{0}/cancel', // {0}: orderGroupID
      MODIFY_ORDER: 'order/{0}/modify', // {0}: orderGroupID
      GET_ORDER_DETAIL: 'order/{0}', // {0}: orderGroupID
      GET_ORDER_FEES: 'order/getOrderFees'
    },
    FUND:{
      GET_CASH_INSTRUCTION_ENQUIRY: 'fund/cashinstructionsenquiry',
      CASH_DEPOSIT: 'fund/cashdeposit',
      CASH_WITHDRAWAL: 'fund/cashwithdrawal',
      CAHS_TRANSFER: 'fund/fundTransfer',
      CAHS_TRANSFER_ENQUIRY: 'fund/fundTransferEnquiry',
      QUERY_CURRENCY_CONVERSION:'fund/queryCurrencyConversion',
      FOREIGN_EXCHANGE:'fund/foreignExchange',
      FOREIGN_EXCHANGE_ENQUIRY:'fund/foreignExchangeEnquiry',
      CASH_DEPOSIT_WITHDRAWAL_FEE_ENQUIRY:'fund/cashDepositWithdrawalFeeEnquiry',
      WITHDRAWABLE_BALANCE_ENQUIRY:'fund/withdrawableBalanceEnquiry',
        GET_MASTER_ENQUIRY:'instrument/instrumentMasterEnquiry',
    },
    STOCK: {
      GET_INSTRUMENT_DETAIL: 'instrument/{0}', // {0}: instrumentID
      GET_GOOD_TILL_DATE: 'listgoodtilldate',
      GET_SPREAD_TABLE: 'instrument/getspreadtable'
    },
    AAStock:{
      AA_STOCK: 'aastocks'
    },
    Message:{
      ENQUIRY_E_MESSAGE: 'message/enquiryEMessage',
      DELETE_E_MESSAGE: 'message/deleteEMessage'
    }
  },
  wAUTH: {
    WIN_VEST_LOGIN: 'services/v1/user/login',
    WIN_VEST_LOGOUT: 'services/v1/user/logout',
    WIN_VEST_REGISTER: 'services/v1/user/register',
    WIN_VEST_VIEW_CUSTOMER: 'services/v1/customer/{0}',
    WIN_VEST_UPDATE_CUSTOMER: 'services/v1/customer/{0}',
    WIN_VEST_ENQUIRY_WATCHLIST: 'services/v1/flag/{0}/flaggings',
    WIN_VEST_MANAGE_WATCHLIST:'services/v1/flag/watchlist2',
    WIN_VEST_ENQURY_QUETO_HISTORY:'/services/search/system/{0}/keywords',
    WIN_VEST_MANAGE_QUETO_HISTORY:'services/v1/flag/instrument_quote_stats',
    WIN_VEST_GENERATE_DEVICE_ID: 'services/v1/device/generate_device_id',
    WIN_VEST_CREATE_WATCHLIST: 'services/v1/flag',
    WIN_VEST_DELETE_WATCHLIST: 'services/v1/flag/{0}',
    WIN_VEST_POST_LIST: 'services/v1/customer/{0}/posts',
	  WIN_VEST_SUBSCRIBE: 'services/v1/customer/{0}/subscribe',
	  WIN_VEST_UNSUBSCRINE: 'services/v1/customer/{0}/unsubscribe',
    VIRTUAL_TRADING_WATCHLIST:'services/v1/flag/{0}/collections',
    VIRTUAL_TRADING_USER_INFO:'services/v1/customer/{0}/portfolios',
    VIRTUAL_TRADING_TRADING_ACCOUNT:'services/v1/client/{0}/activity',
    VIRTUAL_TRADING_RANKING:'services/v1/customer/{0}/ladder',
    VIRTUAL_TRADING_COMPETITION_LIST:'services/v1/customer/{0}/games',
    VIRTUAL_TRADING_PORTFOLIOS:'services/v1/customer/{0}/portfolios',
    VIRTUAL_TRADING_MANAGE_WATCHLIST:'services/v1/flag/watchlist',
    VIRTUAL_TRADING_ORDER_ENQUIRY:'services/router/order',
    VIRTUAL_TRADING_CREAT_WATCHLIST:'services/v1/flag/',
  },
  wUSER: {
    UPDATE_PREFERENCES: 'services/v1/app/settings',
    GET_PREFERENCES: 'services/v1/app/{0}/settings', // {0}: uuid
    SWITCH_LANGUAGE: 'services/v1/lang/{0}/switch', // {0}: uuid
    PREFERENCE: 'services/v1/preference/{0}' // {0}: uuid
  },
  wCOMMON: {
    RETRIEVE_REGION: 'services/v1/customer/regions/ds'
  },
  wFORUM: {
    USER_ACTIVITY_STREAM: 'services/v1/customer/{0}/feeds', // {0}: id
    POST_ARTICLE: 'services/v1/content',
    ATTACH_FILE_TO_POST: 'services/v1/file/{0}/attach/node', // {0}: postID
    GET_COMMENTS_PER_POST: 'services/v1/content/{0}/comments', // {0}: postID
    WRITE_COMMENT: 'services/v1/content/{0}/comment', // {0}: postID
    GET_REPLIES_PER_COMMENT: 'services/v1/comment/{0}/replies', // {0}: commentID // Can not find this API
    FLAG_TOGGLE: 'services/v1/flag/{0}/toggle', // {0}: flag name
    SEARCH_SYSTEM: 'services/search/system',
    SEARCH_HISTORY : 'services/search/keyword/history',
    SEARCH_MARKET_ACTIVE: "services/search/system/topsearch/instrument",
    REPORT_TYPE:"services/v1/speech/spam_options/ds", 
    MARKET_POST:"services/v1/content",
    ATTACH_FILE_TO_POST:"services/v1/file/{0}/attach/node",  // {0}:nid
    SPEECH_REPORT:"services/v1/speech/report",
    MARKET_COMMENT_REPLY:"services/v1/comment/{0}/reply",  // {0}:cid
    MARKET_COMMENT_POST_DETAIL:"services/v1/content/{0}/comments",   // {0}:nid
    SERIES_PRODUCT:"options/seriesProductEnquiry",
  },
  iIPO: {
    LISTING_ENQUIRY: 'ipolistingenquiry',
    APP_STATUS_ENQUIRY: 'ipoappstatusenquiry',
    ALLOTMENT_RESULT: 'ipoallotmentenquiry',
    LISTED_FOCUS: 'ipolistedfocusenquiry',
    DETAIL_ENQUIRY: 'ipodetailsenquiry',
    APPLY: 'ipoapply',
    CANCEL:'ipocancel',
    APPLIEDDETAILSENQUIRY:'ipoAppliedDetailsEnquiry',
    IPOMODIFY:'ipoModify',
    QUERY_IPO_INTEREST_RATE_PLAN_FEE: 'queryIpoInterestRatePlanFee',
  },
  iCA: {
    SHARE_HOLDERS_EQUITY_LIST: 'shareholdersequitylist',
    SHARE_HOLDERS_EQUITY_CONFIRM: 'shareholdersequityconfirm',
    SHARE_HOLDERS_EQUITY_ENQUIRY: 'shareholdersequityenquiry',
    SHARE_HOLDERS_EQUITY_INPUT: 'shareholdersequityinput'
  },
  iCONFIG: {
    GET_CONFIG_SETTINGS: 'config/configsettings'
  },
  wsSTOCK: {
    QUOTE_DATA: 'wss://ttldemo4.tx-tech.com/pubsub',
    STREAMING: appConfigConstants.MDSStreamingAPI,
    SNAPSHOT: appConfigConstants.MDSSnapshotAPI,
    MDS9997: appConfigConstants.MDS9997API,
    OTHERS: appConfigConstants.MDSOthersAPI,
    PROXY: appConfigConstants.MDSProxyAPI,
  }
}

export const NOT_SET_COOKIE_LIST = [
  ENDPOINT_REQUEST.wAUTH.WIN_VEST_LOGIN,
  ENDPOINT_REQUEST.wAUTH.WIN_VEST_LOGOUT,
  ENDPOINT_REQUEST.wCOMMON.RETRIEVE_REGION
]
